<template>
    <v-container fluid>
        <v-row class="mt-6 ml-6">
            <h1>建立問卷</h1>
        </v-row>
        <v-row class="mt-6 ml-6">
            <h3>請選擇問卷種類:</h3>
        </v-row>
        <v-row class="ml-6 pl-6">
            <v-radio-group v-model="survey_type">
                <v-radio label="一般問卷" :value="1"></v-radio>
                <v-radio label="子母問卷" :value="2"></v-radio>
            </v-radio-group>
        </v-row>
        <v-row class="mt-6 ml-6">
            <h3>基本資料</h3>
        </v-row>
        <v-row class="ml-6 pl-6">
            <h3 class="mt-6">問卷名稱:</h3>
            <v-col cols="12" sm="12">
                <v-text-field v-model="survey_title" single-line="" class="input_400" label="請輸入問卷名稱"></v-text-field>
            </v-col>
            <h3>所屬廠商:</h3>
            <v-col cols="12" sm="12">
                <v-select v-model="vendor" :items="vendor_list" item-text="name" item-value="id" placeholder="請選擇廠商" class="input_400" outlined></v-select>
            </v-col>
        </v-row>
        <v-row class="mt-6 ml-6">
            <h3 class="mt-2">問卷題目</h3>
        </v-row>
        <div v-for="(q, idx) in question_list" :key="idx">
            <choice v-if="q.type==1" @update="question_update" :index="idx+1" :tid="q.id" :question="q.question" @deleted="deleted"></choice>
            <essay v-if="q.type==2" @update="question_update" :index="idx+1" :tid="q.id" :question="q.question" @deleted="deleted"></essay>
            <matrix v-if="q.type==3" @update="question_update" :index="idx+1" :tid="q.id" :question="q.question" @deleted="deleted"></matrix>
            <multiplechoice v-if="q.type==4" @update="question_update" :index="idx+1" :tid="q.id" :question="q.question" @deleted="deleted"></multiplechoice>
            <choicewithtext v-if="q.type==5" @update="question_update" :index="idx+1" :tid="q.id" :question="q.question" @deleted="deleted"></choicewithtext>

        </div>

        <v-row class="mt-6 ml-1">
            <v-btn @click="question_type=-1; add_question_dialog=true" color="primary">新增題目</v-btn>
        </v-row>

        <v-row class="mt-6 mr-1">
            <v-spacer></v-spacer>
            <v-btn @click="save" class="ml-3 mt-3" color="success">儲存</v-btn>
        </v-row>

        <v-dialog v-model="add_question_dialog" max-width="600px" persistent>
            <v-card style="overflow: hidden;">
                <v-card-title class="headline grey lighten-2">題型設定
                    <v-spacer/>
                    <v-icon @click="add_question_dialog=false">mdi-close</v-icon>
                </v-card-title>
                <v-card-text class="mt-4 pa-6">
                    <v-row>
                        <v-select v-model="question_type" :items="[{label: '單選題', value: 1}, {label:'簡答題', value: 2}, {label:'矩陣題', value: 3}, {label: '多選題', value: 4}, {label:'單選題加註文字', value: 5}]" item-text='label' item-value='value' label="請選擇題型" class="input_200" outlined></v-select>
                    </v-row>
                </v-card-text>
                <v-card-actions class="pl-6 pr-6" justify="center">
                    <v-row justify="center">
                        <v-btn color="success" @click="add_question_submit" block>送出</v-btn>
                    </v-row>
                </v-card-actions>
            </v-card>
        </v-dialog>

    </v-container>
</template>

<script>
import ContentIconCard from '../materials/ContentIconCard'
import Choice from '../materials/question/Choice'
import Essay from '../materials/question/Essay'
import Matrix from '../materials/question/Matrix'
import Multiplechoice from '../materials/question/Multiplechoice'
import Choicewithtext from '../materials/question/Choicewithtext'

import bus from '../nav/bus'

var host_url = process.env.VUE_APP_HOST_URL

export default {
    components:{ContentIconCard, Choice, Essay, Matrix, Multiplechoice, Choicewithtext},
    data(){
        return {
            survey_type: 1,
            survey_title: "",
            vendor_list: [],
            vendor: -1,

            add_question_dialog: false,
            question_type: 1,
            quetion_spacing: 3,
            question_list: [],

            survey_id: -1,
        }
    },
    created() {
        let check = 's' in this.$route.query
        // 複製模式
        if(check) {
            this.survey_id = this.$route.query.s
            this.get_question_list()
        }
    },
    mounted(){
        this.get_vendor_list()
    },
    methods: {
        get_question_list(){
            let post_data = {survey_id: this.survey_id}

            axios.post(host_url+'get_question_list/', post_data)
            .then(response => {
                var tmp = response.data
                if(tmp.status == true){
                    this.question_list = tmp.question_list
                }
                else{
                    bus.$emit('alert', {msg: tmp.msg, title: "提示",　check: "我知道了"})
                }
            })
            .catch((error)=> {
                console.log(error);
            });
        },
        get_vendor_list(){
            axios.get(host_url+'get_vendor_list/')
            .then(response => {
                var tmp = response.data
                this.vendor_list = tmp.vendor_list
                if(this.vendor_list.length == 1)
                    this.vendor = this.vendor_list[0].id
            })
            .catch((error)=> {
                console.log(error);
            });
        },
        question_update(val){
            console.log("id", val)
            let idx = this.question_list.findIndex(e=>e.id==val[0])
            console.log(idx)
            console.log(this.question_list[idx])
            this.question_list[idx]['question'] = val[1]
        },
        deleted(val){
            this.question_list.splice(this.question_list.findIndex(e=>e.id==val), 1)
        },
        check_data(post_data){
            let msg = ""
            if(post_data['survey_title'] == "")
                msg += "問卷名稱尚未填寫!\n"
            if(post_data['vendor'] == "")
                msg += "所屬廠商尚未填寫!\n"
            let q_list = post_data['question_list']

            if(q_list.length == 0)
                msg += "尚未新增問題!\n"

            for(let idx in q_list){
                let num = Number(idx)+1
                let tmp = q_list[idx]
                if(tmp['type'] == 1){
                    if(tmp['question']['title'] == '')
                        msg += "問題"+num+": 問題尚未填寫!\n"
                    if(tmp['question']['choice'].length == 0){
                        msg += "問題"+num+": 尚未新增選項!\n"
                    }
                    else{
                        console.log(tmp['question']['choice'])
                        for(let idx2 in tmp['question']['choice']){
                            let num2 = Number(idx2)+1
                            let choice = tmp['question']['choice'][idx2]
                            if(String(choice['title']) == "")
                                msg += "問題"+num+": 第"+num2+"選項內容尚未填寫!\n"
                            if(String(choice['score']) == "")
                                msg += "問題"+num+": 第"+num2+"選項分數尚未填寫!\n"
                        }
                    }
                }
                if(tmp['type'] == 2){
                    if(tmp['question']['title'] == '')
                        msg += "問題"+num+": 問題描述尚未填寫!\n"
                }
                if(tmp['type'] == 3){
                    if(tmp['question']['title'] == '')
                        msg += "問題"+num+": 問題描述尚未填寫!\n"

                    if(tmp['question']['title_list'].length == 0){
                        msg += "問題"+num+": 尚未新增子問題!\n"
                    }
                    else{

                        let tlist = tmp['question']['title_list']
                        for(let t of tlist)
                            if(t.title == '')
                                msg += "問題"+num+": 子問題不可空白!\n"
                    }
                }
                if(tmp['type'] == 4){
                    if(tmp['question']['title'] == '')
                        msg += "問題"+num+": 問題尚未填寫!\n"
                    if(tmp['question']['choice'].length == 0){
                        msg += "問題"+num+": 尚未新增選項!\n"
                    }
                    else{
                        console.log(tmp['question']['choice'])
                        for(let idx2 in tmp['question']['choice']){
                            let num2 = Number(idx2)+1
                            let choice = tmp['question']['choice'][idx2]
                            if(String(choice['title']) == "")
                                msg += "問題"+num+": 第"+num2+"選項內容尚未填寫!\n"
                            // if(String(choice['score']) == "")
                            //     msg += "問題"+num+": 第"+num2+"選項分數尚未填寫!\n"
                        }
                    }
                }
                if(tmp['type'] == 5){
                    if(tmp['question']['title'] == '')
                        msg += "問題"+num+": 問題尚未填寫!\n"
                    if(tmp['question']['choice'].length == 0){
                        msg += "問題"+num+": 尚未新增選項!\n"
                    }
                    else{
                        console.log(tmp['question']['choice'])
                        for(let idx2 in tmp['question']['choice']){
                            let num2 = Number(idx2)+1
                            let choice = tmp['question']['choice'][idx2]
                            if(String(choice['title']) == "")
                                msg += "問題"+num+": 第"+num2+"選項內容尚未填寫!\n"
                            // if(String(choice['score']) == "")
                            //     msg += "問題"+num+": 第"+num2+"選項分數尚未填寫!\n"
                        }
                    }
                }
            }
            return msg
        },
        save(){
            let post_data = {
                survey_type: this.survey_type,
                survey_title: this.survey_title,
                vendor: this.vendor,
                question_list: this.question_list,
            }
            let msg = this.check_data(post_data)
            if(msg != ""){
                bus.$emit('alert', {msg: msg, title: "提示",　check: "我知道了"})
                return
            }
            axios.post(host_url+'create_question/', post_data)
            .then(response => {
                var tmp = response.data
                if(tmp.status == true){
                    this.$router.push('/question_assign?s='+tmp.survey_id)
                }
                else{
                    bus.$emit('alert', {msg: '新增失敗！', title: "提示",　check: "我知道了"})
                }
            })
            .catch((error)=> {
                console.log(error);
            });
        },
        pos_change(name, item, type_){
            let item_list
            if(name=='header'){
                item_list = this.headers
            }
            else{
                item_list = this.table_data
            }
            let idx = item_list.findIndex(e=>e.text==item.text)
            if(type_ == "up" && idx>1){
                let tmp = item_list[idx-1]
                this.$set(item_list, idx-1, item_list[idx])
                this.$set(item_list, idx, tmp)
            }
            if(type_ == "down" && idx!=item_list.length-1){
                let tmp = item_list[idx+1]
                this.$set(item_list, idx+1, item_list[idx])
                this.$set(item_list, idx, tmp)
            }
        },
        add_question_submit(){
            let tmp = {}
            if(this.question_type == 1){
                tmp['title'] = ""
                tmp['choice'] = []
                tmp['trigger_msg'] = ""
            }

            if(this.question_type == 2){
                tmp['title'] = ""
                tmp['description'] = ""
            }

            if(this.question_type == 3){
                tmp['title'] = ''
                tmp['headers_list'] = []
                tmp['title_list'] = []
                tmp['description_list'] = []
            }
            if(this.question_type == 4){
                tmp['title'] = ""
                tmp['choice'] = []
                tmp['trigger_msg'] = ""
            }
            if(this.question_type == 5){
                tmp['title'] = ""
                tmp['description'] = ""
                tmp['choice'] = []
                tmp['trigger_msg'] = ""
            }
            this.question_list.push({type: this.question_type, question: tmp, id: this.question_list.length*-1-1})
            this.add_question_dialog = false
            this.question_type = ''
        },
    },
}
</script>

<style lang="scss" scoped>

::v-deep .input_400{
    max-width: 400px;
}

::v-deep .input_100{
    max-width: 100px;
}

::v-deep .input_700{
    max-width: 700px;
}


</style>
